import React from "react";

const AlertIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({className, ...props}) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    role="img"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5999 12.5C21.5999 15.0461 20.5885 17.4879 18.7881 19.2883C16.9878 21.0886 14.546 22.1 11.9999 22.1C9.45382 22.1 7.01203 21.0886 5.21168 19.2883C3.41133 17.4879 2.3999 15.0461 2.3999 12.5C2.3999 9.95395 3.41133 7.51215 5.21168 5.7118C7.01203 3.91145 9.45382 2.90002 11.9999 2.90002C14.546 2.90002 16.9878 3.91145 18.7881 5.7118C20.5885 7.51215 21.5999 9.95395 21.5999 12.5V12.5ZM13.1999 17.3C13.1999 17.6183 13.0735 17.9235 12.8484 18.1486C12.6234 18.3736 12.3182 18.5 11.9999 18.5C11.6816 18.5 11.3764 18.3736 11.1514 18.1486C10.9263 17.9235 10.7999 17.6183 10.7999 17.3C10.7999 16.9818 10.9263 16.6765 11.1514 16.4515C11.3764 16.2265 11.6816 16.1 11.9999 16.1C12.3182 16.1 12.6234 16.2265 12.8484 16.4515C13.0735 16.6765 13.1999 16.9818 13.1999 17.3V17.3ZM11.9999 6.50002C11.6816 6.50002 11.3764 6.62645 11.1514 6.8515C10.9263 7.07654 10.7999 7.38176 10.7999 7.70002V12.5C10.7999 12.8183 10.9263 13.1235 11.1514 13.3486C11.3764 13.5736 11.6816 13.7 11.9999 13.7C12.3182 13.7 12.6234 13.5736 12.8484 13.3486C13.0735 13.1235 13.1999 12.8183 13.1999 12.5V7.70002C13.1999 7.38176 13.0735 7.07654 12.8484 6.8515C12.6234 6.62645 12.3182 6.50002 11.9999 6.50002Z"
      fill="currentColor"
    />
  </svg>
);

export default AlertIcon;